import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { DotNavigationTheme, DotNavigation } from '..';

class DotNavigationVisual extends React.Component<any> {
  render() {
    return (
      <VisualTestContainer>
        <DotNavigation {...this.props} />
      </VisualTestContainer>
    );
  }
}

const SHORT_COMPONENT_LENGTH = 5;

const LONG_COMPONENT_LENGTH = 6;

const shortComponentCases = new Array(SHORT_COMPONENT_LENGTH)
  .fill(null)
  .map((_, index) => ({
    it: `currentIndex = ${index}`,
    props: {
      currentIndex: index,
    },
  }));

const longComponentCases = new Array(LONG_COMPONENT_LENGTH)
  .fill(null)
  .map((_, index) => ({
    it: `length = ${LONG_COMPONENT_LENGTH}, currentIndex = ${index}`,
    props: {
      length: LONG_COMPONENT_LENGTH,
      currentIndex: index,
    },
  }));

const tests = [
  {
    describe: 'DotNavigation',
    its: [
      {
        it: 'default',
        props: {},
      },
      {
        it: 'length < 0',
        props: {
          length: -1,
        },
      },
      {
        it: 'length > 0 && length < 5',
        props: {
          length: 3,
        },
      },
      {
        it: `length = 10, currentIndex = 5`,
        props: {
          length: 10,
          currentIndex: 5,
        },
      },
      {
        it: 'length = 0',
        props: {
          length: 0,
        },
      },
      {
        it: `length > ${SHORT_COMPONENT_LENGTH}`,
        props: {
          length: LONG_COMPONENT_LENGTH,
        },
      },
      {
        it: 'light theme',
        props: {
          theme: DotNavigationTheme.Light,
        },
      },
      {
        it: 'with safety border',
        props: {
          showBorder: true,
        },
      },
      {
        it: 'light theme with safety border',
        props: {
          theme: DotNavigationTheme.Light,
          showBorder: true,
        },
      },
      {
        it: 'currentIndex < 0',
        props: {
          currentIndex: -1,
        },
      },
      ...shortComponentCases,
      {
        it: 'currentIndex > length - 1',
        props: {
          currentIndex: SHORT_COMPONENT_LENGTH,
        },
      },
      {
        it: `length = ${LONG_COMPONENT_LENGTH}, currentIndex < 0`,
        props: {
          length: LONG_COMPONENT_LENGTH,
          currentIndex: -1,
        },
      },
      ...longComponentCases,
      {
        it: `length = ${LONG_COMPONENT_LENGTH}, currentIndex > length - 1`,
        props: {
          length: LONG_COMPONENT_LENGTH,
          currentIndex: LONG_COMPONENT_LENGTH,
        },
      },
    ],
  },
  {
    describe: 'DotNavigation variables',
    its: [
      {
        it: 'dark theme',
        props: {
          style: {
            '--wst-paragraph-2-color-rgb': '220,20,60',
          },
        },
      },
      {
        it: 'light theme',
        props: {
          style: {
            '--wst-primary-background-color-rgb': '20,180,120',
          },
          theme: DotNavigationTheme.Light,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props }) => {
    storiesOf(`DotNavigation/${describe}`, module).add(it, () => (
      <div style={props.style}>
        <DotNavigationVisual {...props} />
      </div>
    ));
  });
});
